import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Invoice } from './invoice'

export class InvoicesRepository extends BaseRepository<Invoice> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.posApiUrl + '/' + 'invoices', token, cache)
    }

    async upsert(dto: Partial<Invoice>) {
        const { json, statusCode, message } = await this.request.post(
            this.config.posApiUrl + '/invoices/?token=' + this.resolvedToken,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async setTaxInvoiceId(invoiceId: string, taxInvoiceId: string) {
        const { json, statusCode, message } = await this.request.patch(
            this.config.posApiUrl + '/invoices/' + invoiceId + '/tax-invoice?token=' + this.resolvedToken,
            { taxInvoiceId },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getBuyers(from: Date, to: Date) {
        const { json, statusCode, message } = await this.request.get(
            this.config.posApiUrl +
                '/invoices/buyers?from=' +
                from +
                '&to=' +
                to +
                '&token=' +
                this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getComissions(params: { page?: number; from?: Date; to?: Date; query?: string } | any) {
        let queryString = '?'
        for (const key in params) {
            if (params[key]) queryString += key + '=' + params[key] + '&'
        }
        const url =
            this.config.posApiUrl + '/invoices/comissions/' + queryString + 'token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async comissionsChangeStatus(servicesOnInvoicesId: string, active: boolean) {
        const { json, statusCode, message } = await this.request.post(
            this.config.posApiUrl + '/invoices/comissions/status?token=' + this.resolvedToken,
            { id: servicesOnInvoicesId, active },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async comissionsRecalculate(params: { from: Date; to: Date }) {
        let queryString = '?'
        for (const key in params) {
            if (params[key]) queryString += key + '=' + params[key] + '&'
        }
        const url =
            this.config.posApiUrl +
            '/invoices/comissions/recalculate' +
            queryString +
            'token=' +
            this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getEvolution() {
        const url = this.config.posApiUrl + '/invoices/evolution/?token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getTotalByMonth(from: Date, to: Date) {
        const url =
            this.config.posApiUrl +
            '/invoices/total/month?from=' +
            from +
            '&to=' +
            to +
            '&token=' +
            this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getTotalByDay(from: Date, to: Date) {
        const url =
            this.config.posApiUrl +
            '/invoices/total/day?from=' +
            from +
            '&to=' +
            to +
            '&token=' +
            this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
